import { SPECS } from "@/lib/content";
import { useReveal } from "@/lib/useReveal";

export const SpecsTable = () => {
  const { ref, inView } = useReveal();
  return (
    <section className="py-12 sm:py-16 lg:py-20" ref={ref}>
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <h2
          className={`mb-8 text-center font-display text-3xl uppercase text-neutral-900 sm:text-4xl hp-reveal ${
            inView ? "in-view" : ""
          }`}
        >
          Product Specifications
        </h2>
        <div
          className={`overflow-hidden rounded-2xl border border-neutral-200 bg-white hp-reveal ${
            inView ? "in-view" : ""
          }`}
        >
          <table className="w-full text-left" data-testid="specs-table">
            <tbody>
              {SPECS.map(([k, v], i) => (
                <tr key={k} className={i % 2 ? "bg-[var(--hp-page)]" : "bg-white"}>
                  <th className="w-1/2 px-5 py-4 text-sm font-bold text-neutral-800">{k}</th>
                  <td className="px-5 py-4 text-sm text-neutral-600">{v}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-4 text-center text-xs text-neutral-500">
          * Non-hormonal formula with no known side effects.
        </p>
      </div>
    </section>
  );
};
